/* Shopify Forms owns collection, validation and success. This bounded adapter
   only carries existing B2H control tokens into its open shadow root. */
(() => {
  const owners = new Map();
  const styles = `
    input[inputmode="email"] {
      min-height: var(--b2h-field-height, 3.25rem);
      font-size: var(--b2h-field-font-size, 1rem) !important;
      font-family: var(--b2h-font-body, sans-serif) !important;
      border-radius: var(--b2h-field-radius, .5rem) !important;
    }
    button[type="submit"] {
      min-height: var(--b2h-button-height, 3rem);
      border-radius: var(--b2h-button-radius, .5rem) !important;
      font-family: var(--b2h-font-body, sans-serif) !important;
      font-size: var(--b2h-button-font-size, .875rem) !important;
      font-weight: var(--b2h-button-font-weight, 650) !important;
    }
    h2 { font-family: var(--b2h-font-display, Georgia, serif) !important; }
    p { font-size: var(--b2h-text-body-sm, .875rem) !important; line-height: 1.5 !important; }
    :is(input, button, a):focus-visible {
      outline: 2px solid var(--b2h-color-focus, #2d6f73) !important;
      outline-offset: 3px;
    }
  `;
  function init(section) {
    if (owners.has(section)) return;
    const abort = new AbortController();
    // Native product-form retains cart/error ownership. This only updates the
    // selected option's visible price/availability and the shared gallery.
    section.addEventListener('change', event => {
      if (!event.target.matches('[data-pdp-variant]')) return;
      const select = event.target;
      const option = select.selectedOptions[0];
      const form = select.closest('form');
      const button = form.querySelector('[name="add"]');
      button.disabled = option.dataset.available !== 'true';
      button.querySelector('span').textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
      section.querySelector('[data-pdp-price]').textContent = option.dataset.price;
      const gallery = section.querySelector('media-gallery');
      if (option.dataset.mediaId) gallery?.goToMediaId?.(option.dataset.mediaId);
      const slider = section.querySelector('slide-section');
      const swiper = slider?.globalSlide || slider?.swiper;
      const index = [...(swiper?.slides || [])].findIndex(slide => slide.dataset.mediaId === option.dataset.mediaId);
      if (index >= 0) swiper.slideTo(index);
      const url = new URL(location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState({}, '', url);
    }, { signal: abort.signal });
    const shadows = new Map();
    function connect() {
      section.querySelectorAll('shopify-forms-embed').forEach(host => {
        const shadow = host.shadowRoot;
        if (!shadow || shadows.has(shadow)) return;
        function adapt() {
          if (!shadow.querySelector('[data-b2h-rabbit-controls]')) {
            const style = document.createElement('style');
            style.dataset.b2hRabbitControls = '';
            style.textContent = styles;
            shadow.append(style);
          }
          shadow.querySelectorAll('input[inputmode="email"]').forEach(input => {
            input.autocomplete = 'email';
            input.autocapitalize = 'none';
            input.spellcheck = false;
          });
        }
        const observer = new MutationObserver(adapt);
        shadows.set(shadow, observer);
        observer.observe(shadow, {childList: true, subtree: true});
        adapt();
      });
    }
    const observer = new MutationObserver(connect);
    observer.observe(section, {childList: true, subtree: true});
    owners.set(section, () => {abort.abort();observer.disconnect();shadows.forEach(o => o.disconnect());});
    connect();
  }
  const discover = () => document.querySelectorAll('.b2h-rabbit-waitlist-section').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', discover, {once:true});
  else discover();
  document.addEventListener('shopify:section:load', discover);
  document.addEventListener('shopify:section:unload', event => {
    for (const [section, stop] of owners) {
      if (event.target === section || event.target.contains(section)) {stop();owners.delete(section);}
    }
  });
})();
